// extracted by mini-css-extract-plugin
module.exports = {"root":"_3iV7DU1tsOz7du-JGm16jB","star":"_3xsTJ0XowmaUvvcdLlSIHa","notTouchable":"_4uLAZ02d3dV1nRaEaaGYj","filled":"_39z7juyl7ST312Ko3fuyVX"};